/*!
 * Cargauge cart helpers
 * Replaces Shopify's legacy api.jquery.js (only getCart / removeItem were used by the theme).
 * Uses the Shopify Cart Ajax API (/cart.js, /cart/change.js) via fetch.
 */
(function (w) {
  'use strict';
  var Shopify = (w.Shopify = w.Shopify || {});
  var JSON_HEADERS = { Accept: 'application/json' };

  function parse(res) {
    if (!res.ok) { throw new Error('Cart request failed: ' + res.status); }
    return res.json();
  }

  // Shopify.getCart(callback) -> callback(cart)
  Shopify.getCart = function (callback) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: JSON_HEADERS })
      .then(parse)
      .then(function (cart) { if (typeof callback === 'function') { callback(cart); } return cart; })
      .catch(function (e) { if (w.console && console.error) { console.error(e); } });
  };

  // Shopify.removeItem(variantId, callback) -> callback(cart)
  Shopify.removeItem = function (variantId, callback) {
    var body = new URLSearchParams();
    body.set('id', String(variantId));
    body.set('quantity', '0');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(parse)
      .then(function (cart) { if (typeof callback === 'function') { callback(cart); } return cart; })
      .catch(function (e) { if (w.console && console.error) { console.error(e); } });
  };

  // Shopify.resizeImage(src, size) -> resized CDN url (e.g. '160x').
  // The theme's cart dropdown (theme.js) calls this for every cart line. It used to come from Shopify's legacy
  // api.jquery.js, which this file replaced, and jquery.products.min.js only loads on pages that render the
  // "recently viewed" section. Without it the dropdown threw after clearing the list, so cart lines never showed.
  if (typeof Shopify.resizeImage !== 'function') {
    Shopify.resizeImage = function (src, size) {
      if (!src) { return ''; }
      src = String(src);
      if (size == null) { return src; }
      if (size === 'master') { return src.replace(/http(s)?:/, ''); }
      var m = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i);
      if (m) {
        var parts = src.split(m[0]);
        return (parts[0] + '_' + size + m[0]).replace(/http(s)?:/, '');
      }
      return src;
    };
  }
})(window);
